import React, { useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import { createReportSchedule, updateReportSchedule } from '../api/reportsApi'
import ReportScheduleForm, { normalizeScheduleForForm } from './ReportScheduleForm'

export default function ReportScheduleModal({
  open = false,
  onClose,
  prefill = null,
  report = null,
  module = '',
  moduleLabel = 'Reports',
  onChanged,
  onSuccess,
}) {
  const [saving, setSaving] = useState(false)
  const targetData = prefill || report || null
  const initialValue = useMemo(
    () => normalizeScheduleForForm(targetData, module || targetData?.module || targetData?.targetModule),
    [targetData, module],
  )
  const reportTitle = targetData?.reportTitle || targetData?.title || initialValue?.reportTitle || 'Report Dispatch'
  const isEditMode = Boolean(targetData?.id)

  async function handleSubmit(payload) {
    setSaving(true)
    try {
      let res
      if (isEditMode) {
        res = await updateReportSchedule(targetData.id, payload)
      } else {
        res = await createReportSchedule(payload)
      }
      window.dispatchEvent(new Event('report-schedules-updated'))
      onChanged?.(res)
      onSuccess?.(res)
      onClose?.()
    } finally {
      setSaving(false)
    }
  }

  if (!open) return null

  const modalContent = (
    <div
      className="fixed inset-0 z-[1200] flex items-center justify-center bg-black/60 backdrop-blur-xs p-4 sm:p-6 overflow-hidden animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div
        className="w-full max-w-5xl bg-surface-container-lowest rounded-2xl shadow-2xl border border-outline-variant/20 overflow-hidden flex flex-col max-h-[88vh] animate-in zoom-in-95 duration-150"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="shrink-0 px-6 py-3.5 border-b border-surface-container flex items-center justify-between bg-surface-container-low/40">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
              <span className="material-symbols-outlined text-xl">schedule_send</span>
            </div>
            <div>
              <div className="flex items-center gap-2 flex-wrap">
                <h2 className="font-display text-base font-bold text-on-surface">
                  {isEditMode ? 'Edit Schedule' : 'Schedule Report'}
                </h2>
                <span className="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-semibold bg-primary/10 text-primary border border-primary/20">
                  {reportTitle}
                </span>
              </div>
              <p className="text-xs text-on-surface-variant mt-0.5">
                Configure automated periodic generation, tenant SMTP delivery, and recipient audit logs.
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-lg text-on-surface-variant hover:bg-surface-container hover:text-on-surface transition cursor-pointer"
            aria-label="Close modal"
          >
            <span className="material-symbols-outlined text-lg">close</span>
          </button>
        </div>

        {/* Modal Body with Form */}
        <div className="min-h-0 flex-1 flex flex-col overflow-hidden p-5 sm:p-6">
          <ReportScheduleForm
            initialValue={initialValue}
            heading=""
            submitLabel={isEditMode ? 'Update Schedule' : 'Create Schedule'}
            saving={saving}
            onCancel={onClose}
            onSubmit={handleSubmit}
            scrollBody
          />
        </div>
      </div>
    </div>
  )

  return createPortal(modalContent, document.body)
}

